import { REGISTER } from '../../constants/register.constants';
const initialState = {
  loading: false,
  data: false,
  error: '',
};

export function register(state: any = initialState, action: any) {
  switch (action.type) {
    case REGISTER.REGISTER_REQUEST:
      return {
        ...state,
        loading: true,
        data: false,
        error: '',
      };
    case REGISTER.REGISTER_SUCCESS:
      return {
        ...state,
        loading: false,
        data: true,
        error: '',
      };
    case REGISTER.REGISTER_FAILURE:
      return {
        ...state,
        loading: false,
        data: false,
        error: action.error,
      };
    default:
      return state
  }
}
